enum TaskPostServiceStatus {
    NotAnalyzed = 0,
    Pending = 1,
    Concluded = 2,
    Approved = 3
}

export default TaskPostServiceStatus;